/* tslint:disable */
import { ReceiptTransaction } from './receipt-transaction';
import { ReceiptSummary } from './receipt-summary';

/**
 */
export class ReceiptDetail {
    transactions?: ReceiptTransaction[];
    summary?: ReceiptSummary[];
    data?: any[];
}
